/**
 * Creighton Bluejays — Team Configuration
 * Kinetic Ledger design system from Stitch prototype
 */

export const creightonConfig = {
  id: 'creighton',
  sportCode: 'MBB',

  branding: {
    name: 'Creighton Bluejays',
    shortName: 'Creighton',
    abbreviation: 'CU',
    tagline: 'Coaching Intelligence Dashboard',
    organization: 'Creighton University',
    conference: 'Big East',
  },

  colors: {
    primary: '#FED603',           // Kinetic Ledger gold
    primaryHover: '#E8C200',
    secondary: '#10141a',         // Deep surface base
    accent: '#0c92f1',            // Tertiary cyan from Stitch
    background: '#10141a',        // Surface base (Stitch: surface)
    surface: '#181c22',           // Surface container low
    surfaceHover: '#1c2026',      // Surface container
    elevated: '#262a31',          // Surface container high
    surfaceHighest: '#31353c',    // Surface container highest
    border: 'rgba(77, 71, 50, 0.15)', // outline_variant at 15% (Ghost Border)
    text: {
      primary: '#dfe2eb',         // on_background
      secondary: '#999077',       // outline
      onPrimary: '#3a3000',       // on_primary
    },
    status: {
      success: '#10B981',
      warning: '#f59e0b',
      error: '#ffb4ab',           // Stitch error
      info: '#0a7ac8',            // tertiary_fixed_dim
    },
    // Stitch named colors for direct access
    stitch: {
      primaryContainer: '#fed603',
      primaryFixed: '#ffe16d',
      primaryFixedDim: '#e8c200',
      secondaryContainer: '#414a53',
      tertiaryContainer: '#0c92f1',
      surfaceBright: '#353940',
      surfaceDim: '#10141a',
      outlineVariant: '#4d4732',
      errorContainer: '#93000a',
      onErrorContainer: '#ffdad6',
      onTertiaryContainer: '#006a70',
    },
  },

  logos: {
    primary: '/logos/creighton-bluejays.svg',
    icon: '/logos/creighton-icon.svg',
    alt: 'Creighton Bluejays Logo',
  },

  analysis: {
    systemPromptAdditions: `
You are analyzing basketball data for Creighton University Bluejays, a Division I program in the Big East Conference.
Focus on opponent tendencies, matchup analysis, and actionable coaching insights.
Use language appropriate for a college basketball coaching staff.
`,
    focusAreas: [
      'Opponent scouting reports',
      'Matchup analysis',
      'Player development tracking',
      'Transfer portal intelligence',
      'Recruiting evaluation',
    ],
    terminology: {
      platform: 'SLAM Coaching Dashboard',
      analyst: 'SLAM Scout',
      report: 'SLAM Scouting Report',
    },
  },

  features: {
    schedule: true,
    scouting: true,
    medical: true,
    staff: true,
    strength: true,
    transferPortal: true,
    exports: {
      pdf: true,
      csv: false,
      json: false,
      email: false,
    },
  },

  // Creighton-specific data
  team: {
    sportsDataKey: 'CREIGH',  // SportsData.io team key
    season: '2025',
    headCoach: 'Greg McDermott',
  },
};
